

































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

/* API */

export default Vue.extend({
  name: 'BreadcrumbItemPicker',
  props: {
    itemRefNumber: {
      type: Number,
      default: null,
    },
    itemTitle: {
      type: String,
      default: '',
    },
    showItemTitle: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array as () => IBreadcrumbItemMenuItem[],
      default: (): IBreadcrumbItemMenuItem[] => [],
    },
  },
})
